import { Market } from 'api'
import { createMarketDetailSelector } from 'selectors/platformSelectors'
import { identityPropsSelector, useParametricSelector } from 'utils'

const marketDetailSelector = createMarketDetailSelector(identityPropsSelector)
export const useMarket = (market: Market | null | undefined) => useParametricSelector(marketDetailSelector, market)
